import React from "react";
import { useTranslation } from "react-i18next";
import "./BoardsDetailTabs.css";

const TAB_ITEMS = [
  { id: "features", labelKey: "sections.products.detailTabs.features" },
  { id: "specifications", labelKey: "sections.products.detailTabs.specifications" },
  { id: "recommendations", labelKey: "sections.products.detailTabs.recommendations" },
  { id: "sustainability", labelKey: "sections.products.detailTabs.sustainability" },
  { id: "downloads", labelKey: "sections.products.detailTabs.downloads" },
];

const BoardsDetailTabs = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="boardsDetailTabs-wrap">
      <div className="boardsDetailTabs-inner">
        <nav className="boardsDetailTabs" aria-label="Product sections">
          {TAB_ITEMS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`boardsDetailTabs-tab ${
                activeTab === tab.id ? "is-active" : ""
              }`}
              onClick={() => onTabChange(tab.id)}
            >
              {t(tab.labelKey)}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default BoardsDetailTabs;
